import { gql } from '@apollo/client'

/**
 * Plain `gql` rather than gql.tada: `graphql-env.d.ts` is generated from a
 * running backend, and these fields only exist on the FD-614 backend branch.
 * Switch to `graphql()` once that is on develop.
 */
const FIELD_CONFIG_FIELDS = `
  field
  section
  order
  labelOverride
  visibleOnCreate
  requiredOnCreate
  visibleOnEdit
  requiredOnEdit
  canHide
  canRequire
  overridden
`

/** `category` omitted resolves the company standard. */
export const ISSUE_FIELD_CONFIGS_QUERY = gql`
  query IssueFieldConfigs($category: ID) {
    issueFieldConfigs(category: $category) {
      ${FIELD_CONFIG_FIELDS}
    }
  }
`

export const SET_ISSUE_FIELD_CONFIGS_MUTATION = gql`
  mutation SetIssueFieldConfigs($configs: [IssueFieldConfigInput!]!) {
    setIssueFieldConfigs(configs: $configs) {
      ok
      issueFieldConfigs {
        ${FIELD_CONFIG_FIELDS}
      }
    }
  }
`

export const SET_ISSUE_CATEGORY_FIELD_CONFIGS_MUTATION = gql`
  mutation SetIssueCategoryFieldConfigs(
    $category: ID!
    $configs: [IssueCategoryFieldConfigInput!]!
  ) {
    setIssueCategoryFieldConfigs(category: $category, configs: $configs) {
      ok
      issueFieldConfigs {
        ${FIELD_CONFIG_FIELDS}
      }
    }
  }
`

/** `fields` omitted resets every override the category has. */
export const DELETE_ISSUE_CATEGORY_FIELD_CONFIGS_MUTATION = gql`
  mutation DeleteIssueCategoryFieldConfigs($category: ID!, $fields: [String!]) {
    deleteIssueCategoryFieldConfigs(category: $category, fields: $fields) {
      ok
      issueFieldConfigs {
        ${FIELD_CONFIG_FIELDS}
      }
    }
  }
`

const RELATION_CONFIG_FIELDS = `
  relation
  name
  visibleOnCreate
  requiredOnCreate
  visibleOnEdit
  requiredOnEdit
  overridden
`

/** Relations resolved for a category; omit `category` for the standard. */
export const ISSUE_RELATION_CONFIGS_QUERY = gql`
  query IssueRelationConfigs($category: ID) {
    issueRelationConfigs(category: $category) {
      ${RELATION_CONFIG_FIELDS}
    }
  }
`

export const SET_ISSUE_RELATION_CATEGORY_CONFIGS_MUTATION = gql`
  mutation SetIssueRelationCategoryConfigs(
    $category: ID!
    $configs: [IssueRelationCategoryConfigInput!]!
  ) {
    setIssueRelationCategoryConfigs(category: $category, configs: $configs) {
      ok
      issueRelationConfigs {
        ${RELATION_CONFIG_FIELDS}
      }
    }
  }
`

/** `relations` omitted resets every relation override the category has. */
export const DELETE_ISSUE_RELATION_CATEGORY_CONFIGS_MUTATION = gql`
  mutation DeleteIssueRelationCategoryConfigs($category: ID!, $relations: [ID!]) {
    deleteIssueRelationCategoryConfigs(
      category: $category
      relations: $relations
    ) {
      ok
      issueRelationConfigs {
        ${RELATION_CONFIG_FIELDS}
      }
    }
  }
`

/**
 * The settings picker's category list. Separate from the issue module's own
 * category query so `hasFieldConfigs` — the marker for "this category
 * deviates from the standard" — is fetched only where it is shown.
 */
export const ISSUE_FORM_FIELD_CATEGORIES_QUERY = gql`
  query IssueFormFieldCategories {
    allIssueCategories {
      edges {
        node {
          id
          name
          hasFieldConfigs
        }
      }
    }
  }
`
